export default () => ({
  obraId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  responsavelId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  regionalId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  secaoRH: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  funcionariofuncao: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  motivoViagemId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  paisDestino: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  dataInicio: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  dataFim: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  funcionarioEstadoCivi: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  paisOrigemID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  paisOrigemPreSelecionaoID: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  paisDestinoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  paisDestinoPreSelecionadoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  estadoOrigemID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  estadoDestinoID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  cidadeDestinoId: {
    value: null,
    options: [],
    required: true,
    state: null,
    code: null
  },
  cidadeDestinoFlyId: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  cidadeOrigemId: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  passagem: {
    value: false,
    options: [],
    required: false,
    state: null,
    code: null
  },
  funcionarioId: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  valorTotal: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  valorSolicitado: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  termoPrevisaos: {
    value: [],
    options: [],
    required: false,
    state: null,
    code: null
  },
  tipoPassagemVoo: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  dataInicioVoo: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  dataFimVoo: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  dataDespesa: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  quantidade: {
    value: 1,
    options: [],
    required: false,
    state: null,
    code: null
  },
  somenteArea: {
    value: false,
    options: [],
    required: false,
    state: null,
    code: null
  },
  paisOrigemFlyID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  estadoOrigemFlyID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  cidadeOrigemFlyId: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  paisDestinoFlyID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  estadoDestinoFlyID: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  observacao: {
    value: null,
    options: [],
    required: false,
    state: null,
    code: null
  },
  semAdiantamento: {
    value: false,
    options: [],
    required: false,
    state: null,
    code: null
  }
})



// WEBPACK FOOTER //
// ./src/views/private/travelreimbursement/components/InfoModalTravel/form-modal.js